import React, { useState, useEffect } from "react";
import { useLocation, Switch, Redirect, useHistory } from "react-router-dom";
import RESECommandJobDetails from "./job-details/RESECommandJobDetails";
import RESECommandCreateJob from "./create-job/RESECommandCreateJob";

import { TabView, TabPanel } from "primereact/tabview";

const RESECommand = () => {
	const [activeIndex, setActiveIndex] = useState(0);
	const { pathname } = useLocation();
	const history = useHistory();

	useEffect(() => {
		if (pathname === "/admin/rese/rese-agent/job-details") {
			setActiveIndex(0);
		} else if (
			pathname === "/admin/rese/rese-agent/create-job"
		) {
			setActiveIndex(1);
		}
	}, [pathname]);

	const handleTabChange = (e) => {
		if (e.index === 0) {
			setActiveIndex(0);
			history.push("/admin/rese/rese-agent/job-details");
		} else if (e.index === 1) {
			setActiveIndex(1);
			history.push("/admin/rese/rese-agent/create-job");
		}
	};

	return (
		<div style={{ width: "100%" }}>
			<p className="page-label" style={{ padding: "22px 18px 0 18px" }}>
                RESE <i className="pi pi-angle-right"/> Command and Control
            </p>
			<TabView
				activeIndex={activeIndex}
				onTabChange={handleTabChange}
				className="container-fluid"
			>
				<TabPanel header="View Job">
					 <RESECommandJobDetails />
				</TabPanel>
				<TabPanel header="Create Job">
					<RESECommandCreateJob />
				</TabPanel>
			</TabView>
			<Switch>
				<Redirect
					exact
					path="/admin/rese/rese-agent"
					to="/admin/rese/rese-agent/job-details"
				/>
			</Switch>
		</div>
	);
};

export default RESECommand;
